import React from "react";
import { Link } from "react-router-dom";

export default function Refund() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-button">← back to home</Link>
        
        <h1>Refund & Dispute Policy</h1>
        <p className="company-name">Plaza Tech Software LLC</p>
        <p className="last-updated">Last updated: January 2026</p>

        <section>
          <h2>No-Refund Policy</h2>
          <p>
            Plaza Tech Software LLC operates multiple digital products and services across various platforms 
            and domains. All products are delivered electronically and made available immediately upon purchase.
          </p>
          <p>
            Due to the nature of digital delivery and instant access, all sales are final and non-refundable.
          </p>
          <p>By completing a purchase through any Plaza Tech Software LLC platform, you acknowledge and agree that:</p>
          <ul>
            <li>You receive immediate access to digital software and services</li>
            <li>You waive any right to a refund once access has been granted</li>
            <li>No refunds will be provided for unused time, mistaken purchases, or change of mind</li>
          </ul>
          <p className="contact-info">
            Questions? Contact: 📧 <a href="mailto:dan@plaza.tech">dan@plaza.tech</a>
          </p>
        </section>

        <section>
          <h2>Subscriptions</h2>
          <ul>
            <li>Subscriptions may be cancelled at any time</li>
            <li>Cancellation stops future billing</li>
            <li>No partial refunds are issued for unused billing periods</li>
          </ul>
        </section>

        <section>
          <h2>Chargebacks & Disputes</h2>
          <p>We encourage you to contact us before opening a chargeback with your bank.</p>
          <p>Unresolved chargebacks may result in permanent account suspension.</p>
        </section>
      </div>
    </div>
  );
}


